import classNames from 'classnames';
import { omit } from 'lodash-es';
import type { PropsWithChildren } from 'react';

type SmallTextProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement>;

export const SmallText = (props: PropsWithChildren<SmallTextProps>) => (
  <p {...omit(props, 'className')} className={classNames('text-sm leading-6', props.className)}>{props.children}</p>
);

export default SmallText;
